"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const enums_1 = require("@bemlo/enums");
const utils_1 = require("@bemlo/utils");
const constants_1 = require("../../../constants");
const elements_1 = require("../../../elements");
const translate_1 = require("../../../translate");
const EditIcon_1 = require("../components/EditIcon");
const ClickableArea = (0, styled_1.default)(elements_1.Clickable)((props) => ({
    borderRadius: constants_1.theme.border.radius.normal,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: 4,
    height: '100%',
    padding: 8,
    overflow: 'hidden',
    '&:hover': {
        backgroundColor: props.isPlaceholder
            ? constants_1.Color.LIGHTEST_BLUE
            : constants_1.Color.LIGHTER_BLUE,
    },
}));
const FileUploadElement = (0, styled_1.default)(elements_1.Paper)((props) => ({
    display: 'flex',
    gap: 4,
    borderColor: constants_1.Color.TRANSPARENT_BLUE,
    borderStyle: props.isPlaceholder ? 'dashed' : undefined,
    borderWidth: props.isPlaceholder ? constants_1.theme.border.width.thick : undefined,
    boxShadow: props.isPlaceholder ? 'none' : undefined,
    padding: 4,
    transition: constants_1.theme.animation.transition,
    userSelect: 'none',
}));
const FileUpload = ({ fileUpload, onAddClick, onEditClick, onOpenClick, uploadType, }) => {
    const t = (0, translate_1.useTranslations)();
    const isPlaceholder = !fileUpload;
    const isFileUploadPlaceholder = isPlaceholder && uploadType === enums_1.FileUploadType.OTHER;
    return ((0, jsx_runtime_1.jsxs)(FileUploadElement, { design: isPlaceholder ? 'white' : 'blue', isPlaceholder: isPlaceholder, children: [(0, jsx_runtime_1.jsxs)(ClickableArea, { isPlaceholder: isPlaceholder, onClick: fileUpload
                    ? () => onOpenClick(fileUpload)
                    : () => onAddClick(uploadType), children: [!isFileUploadPlaceholder && ((0, jsx_runtime_1.jsx)(elements_1.Text, { bold: true, color: fileUpload ? constants_1.Color.DARKEST_BLUE : constants_1.Color.BLUE, size: 6, noWrap: true, children: fileUpload?.comment
                            ? (0, utils_1.truncate)(fileUpload.comment, 40)
                            : t.$fileUploadType(uploadType) })), (0, jsx_runtime_1.jsx)(elements_1.Text, { color: fileUpload ? constants_1.Color.DARK_BLUE : constants_1.Color.LIGHT_BLUE, size: 6.5, noWrap: true, children: fileUpload?.fetchedAt
                            ? t.candidate_view.file_uploads.fetched_at(t.$date.unix(fileUpload.fetchedAt).format('ll'))
                            : fileUpload?.uploadedAt
                                ? t.candidate_view.file_uploads.uploaded_at(t.$date.unix(fileUpload.uploadedAt).format('ll'))
                                : fileUpload
                                    ? null
                                    : isFileUploadPlaceholder
                                        ? t.candidate_view.file_uploads.upload_document()
                                        : t.candidate_view.file_uploads.upload() })] }), !isPlaceholder && ((0, jsx_runtime_1.jsx)(EditIcon_1.EditIcon, { onClick: () => onEditClick(fileUpload), permissionScope: "fileUploads" }))] }));
};
exports.FileUpload = FileUpload;
